<div class="w-full py-3 px-4">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <img src="/assets/images/stock/order.png" alt="Report" class="size-6 sm:size-8 lg:size-10" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Product</span>
    </div>
  </div>

  <form [formGroup]="productForm">
    <div class="w-full mt-3 mb-4 lg:mb-0">
      <div
        class="w-full bg-[#FFF5F2] p-3 rounded-md grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-9 gap-2 space-y-0.5">

        <div class="col-span-1">
          <div class="relative">
            <input type="text" readonly formControlName="product_code"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-gray-200 rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Product
              Code</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <select (change)="onCategoryChanged($event)" type="text" formControlName="category_id"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" ">
              <option value="" selected hidden disabled>Select Category</option>
              <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name}}</option>
            </select>
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Product
              Category</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" readonly formControlName="category_code"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-gray-50 rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Category
              Code</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" formControlName="name" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Product
              Name</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" formControlName="cost_price" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 no-spinner font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Cost
              per product</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" formControlName="selling_price" (keydown.enter)="focusNext($event)"
              class="block no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Selling
              Price / Mrp</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" formControlName="quantity" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white no-spinner rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 start-1">Quantity
              in Stock</label>
          </div>
        </div>

        <div class="col-span-2 sm:col-span-1">
          <div class="h-full flex items-center justify-end gap-3">

            <!-- ASSIGN (ADD) BUTTON -->
            <p *ngIf="addbutton" (click)="onSubmit()"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#0BB60B] font-medium cursor-pointer">
              <svg fill="#0BB60B" viewBox="0 0 56.00 56.00" xmlns="http://www.w3.org/2000/svg" stroke="#0BB60B"
                class="size-6 lg:size-8">
                <g transform="translate(9.52,9.52), scale(0.66)">
                  <rect x="0" y="0" width="56" height="56" fill="#ffffff"></rect>
                </g>
                <path
                  d="M 13.7851 49.5742 L 42.2382 49.5742 C 47.1366 49.5742 49.5743 47.1367 49.5743 42.3086 L 49.5743 13.6914 C 49.5743 8.8633 47.1366 6.4258 42.2382 6.4258 L 13.7851 6.4258 C 8.9101 6.4258 6.4257 8.8398 6.4257 13.6914 L 6.4257 42.3086 C 6.4257 47.1602 8.9101 49.5742 13.7851 49.5742 Z M 27.9882 39.6367 C 26.6523 39.6367 25.9492 38.6758 25.9492 37.3164 L 25.9492 30.0274 L 18.2617 30.0274 C 16.8788 30.0274 15.9179 29.3008 15.9179 28.0118 C 15.9179 26.6758 16.8320 25.9258 18.2617 25.9258 L 25.9492 25.9258 L 25.9492 18.1680 C 25.9492 16.8086 26.6523 15.8477 27.9882 15.8477 C 29.2773 15.8477 30.0742 16.7617 30.0742 18.1680 L 30.0742 25.9258 L 37.7851 25.9258 C 39.2148 25.9258 40.1054 26.6758 40.1054 28.0118 C 40.1054 29.3008 39.1679 30.0274 L 30.0742 30.0274 L 30.0742 37.3164 C 30.0742 38.7227 29.2773 39.6367 27.9882 39.6367 Z">
                </path>
              </svg> Add
            </p>

            <!-- UPDATE BUTTON -->
            <p *ngIf="!addbutton" (click)="updateForm()"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#649dcd] font-medium cursor-pointer">
              <svg class="size-6 lg:size-8" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="5" fill="#649dcd" />
                <mask id="mask0" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="24" height="24">
                  <rect x="3" y="3" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0)">
                  <path
                    d="M11.6 25.5L9.7 22.3L6.1 21.5L6.45 17.8L4 15L6.45 12.2L6.1 8.5L9.7 7.7L11.6 4.5L15 5.95L18.4 4.5L20.3 7.7L23.9 8.5L23.55 12.2L26 15L23.55 17.8L23.9 21.5L20.3 22.3L18.4 25.5L15 24.05L11.6 25.5ZM12.45 22.95L15 21.85L17.6 22.95L19 20.55L21.75 19.9L21.5 17.1L23.35 15L21.5 12.85L21.75 10.05L19 9.45L17.55 7.05L15 8.15L12.4 7.05L11 9.45L8.25 10.05L8.5 12.85L6.65 15L8.5 17.1L8.25 19.95L11 20.55L12.45 22.95ZM13.95 18.55L19.6 12.9L18.2 11.45L13.95 15.7L11.8 13.6L10.4 15L13.95 18.55Z"
                    fill="white" />
                </g>
              </svg> Update
            </p>

            <!-- CLEAR BUTTON -->
            <p (click)="clearForm()"
              class="flex items-center gap-1 text-sm lg:text-lg text-[#BB0000] font-medium cursor-pointer">
              <svg class="size-5 lg:size-7" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.5" width="30" height="30" rx="5" fill="#BB0000" />
                <path
                  d="M7.06189 17C7.02104 16.6724 7 16.3387 7 16C7 11.5817 10.5817 8 15 8C17.5006 8 19.7332 9.14727 21.2002 10.9442M21.2002 10.9442V8M21.2002 10.9442V10.9999L18.2002 11M22.9381 15C22.979 15.3276 23 15.6613 23 16C23 20.4183 19.4183 24 15 24C12.6106 24 10.4659 22.9525 9 21.2916M9 21.2916V21H12M9 21.2916V24"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg> Clear
            </p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- LIST SECTION -->
<div class="w-full py-3 px-4">
  <p class="font-semibold text-sm sm:text-base lg:text-xl text-444 mb-4">Product List</p>
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table class="w-full table border border-[#D9D9D9] border-separate border-spacing-0 bg-white">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 border-r border-[#D9D9D9]">Product Code</th>
          <th class="p-2 border-r border-[#D9D9D9] text-left">Product Name</th>
          <th class="p-2 border-r border-[#D9D9D9] text-left">Product Category</th>
          <th class="p-2 border-r border-[#D9D9D9] text-left">Category Code</th>
          <th class="p-2 border-r border-[#D9D9D9]">Cost Per Product</th>
          <th class="p-2 border-r border-[#D9D9D9]">Selling Price / MRP</th>
          <th class="p-2 border-r border-[#D9D9D9]">Quantity in Stock</th>
          <th class="p-2 text-center">Actions</th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let item of otherProductsList">
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{ item.product_code }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ item.name }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ item.category?.name || '-' }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9]">{{ item.category?.code || '-' }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{ item.cost_price }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{ item.selling_price }}</td>
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{ item.quantity }}</td>
          <td class="p-2 border-b border-[#D9D9D9] text-center">
            <div class="flex items-center justify-center gap-2">
              <!-- PATCH BUTTON -->
              <button class="cursor-pointer bg-transparent border-none" (click)="patchProduct(item)">
                <svg viewBox="0 0 24 24" fill="none" class="size-5 lg:size-6">
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
              <!-- DELETE BUTTON -->
              <button class="cursor-pointer bg-transparent border-none" (click)="onDelete(item.id)">
                <svg viewBox="0 0 24 25" fill="none" class="size-5 lg:size-6">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>